// Entry point for the FrameRunning frontend bundle. Replaces the legacy
// Grunt pipeline (sass + postcss/autoprefixer + jshint + concat). Built with
// Vite; output lands at wwwroot/css/release.css + wwwroot/js/release.js so
// the existing Razor layout (Views/FrameRunning/Master.cshtml) needs no
// changes.

import '../scss/main.scss';

// --- Global shims -----------------------------------------------------
// Several vendored/ported plug-ins below (typeahead.js, datatables.net, the
// DataTables moment plug-in, flickity's/isotope's jQuery bridges) are UMD
// modules written for the pre-ESM-bundler era: they expect `jQuery`/`moment`
// to already be available as globals. This must be the first import in this
// file — see globals.js for why (ESM import hoisting).
import './globals';

// --- Bootstrap 4 (only the pieces actually used by the ported views) --
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';

// --- Vendor plug-ins ----------------------------------------------------
// Bridges Flickity/Isotope onto jQuery — must run before any ported
// component below calls `.flickity()`/`.isotope()`. See bridges.js.
import './bridges';

import Blazy from 'blazy';
window.Blazy = Blazy;

import 'typeahead.js';

import 'datatables.net';
import './vendor/jquery.dataTable.datetime-moment';

// --- Ported app logic ---------------------------------------------------
// Imported in the same order as the legacy scripts/pragmasoft.frontend.config.json
// concat list (scripts/main.js, then each scripts/app/components/*.js file),
// so that jQuery's `$(document).ready` callbacks fire in the original order.
import './app';
import './components/blazy';
import './components/facebook';
import './components/flickity';
import './components/isotope';
import './components/read-progress';
import './components/search';
import './components/athletes';
import './components/world-records';
import './components/ranking';
